declare var angular: ng.IAngularStatic;
export interface INotifyService {
    show(obj: { text?: string, pinTo?: string, hideDelay?: number })
    action(obj:{ text?:string, pinTo ?:string, hideDelay ?:number, action?:string, highlightClass?:string, actionUrl?:string, actionTarget?:string })
}
export class notifyService {
    constructor(private $mdToast, private $q) {
        "ngInject";
    }
    show({ text, pinTo = "right top", hideDelay = 3000 }) {
        this.$mdToast.show(
            this.$mdToast.notify()
                .textContent(text)
                .position(pinTo)
                .hideDelay(hideDelay)
                .parent(angular.element(document.getElementById('Body')))
        )
    }

    action({ text, pinTo = "right top", hideDelay = 10000, action, highlightClass = "md-primary", actionUrl, actionTarget = "_blank" }) {

        return this.$mdToast.show(
            this.$mdToast.action()
                .textContent(text)
                .action(action)
                .actionUrl(actionUrl)
                .actionTarget(actionTarget)
                .highlightClass(highlightClass)// Accent is used by default, this just demonstrates the usage.
                .hideDelay(hideDelay)
                .parent(angular.element(document.getElementById('Body')))
                .position(pinTo)
        )
    }

}


// WEBPACK FOOTER //
// ./src/services/notify/notify.ts